import React from 'react';
import RecordingsShuttle from './RecordingsShuttle';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store/rootReducer';
import { MockService } from 'types/rest/mockServiceTypes';
import { PaneState } from 'components/shuttle/Shuttle';
import {
  fetchAssignedRecordings,
  fetchAvailableRecordings,
  moveRecordingsThunk,
  updateRecordingShuttlePane,
} from 'store/mockServices/mockServiceDetail/mockServiceDetailActions';

interface Props {
  disabled: boolean;
  mockService: MockService;
}

/**
 * Shuttle wrapper for the recordings shuttle which handles the state and dispatches the actions.
 * @param disabled
 * @param mockService
 * @constructor
 */
const MsRecordingsShuttleWrapper = ({ disabled, mockService }: Props) => {
  const shuttleState = useSelector((state: ApplicationState) => state.mockServiceDetails.recordingShuttle);

  const dispatch = useDispatch();

  return (
    <RecordingsShuttle
      disabled={disabled}
      mockService={mockService}
      shuttleState={shuttleState}
      fetchAvailableRecordings={() => {
        dispatch(fetchAvailableRecordings(mockService));
      }}
      fetchAssignedRecordings={() => {
        dispatch(fetchAssignedRecordings(mockService));
      }}
      updateRecordingShuttlePane={(panePosition: 'LEFT' | 'RIGHT', updatedPaneState: PaneState) => {
        dispatch(updateRecordingShuttlePane(panePosition, updatedPaneState));
      }}
      moveRecordings={(position: 'LEFT' | 'RIGHT', selectedRecordings: number[]) => {
        dispatch(moveRecordingsThunk(position, mockService, selectedRecordings));
      }}
    />
  );
};

export default MsRecordingsShuttleWrapper;
